<template>

    <div id="guitar-gallery-modal" class="category-brands" v-if="facetsList.length">
        <h2 class="shop-by" v-if="name">{{ name }}</h2>
        <transition name="slide-toggle">
            <div class="mobile-menu" v-if="visibleMenu">
                <div class="brand-list">
                    <a :href="facet.url" v-for="(facet, index) in facetsList" :key="index" class="category-brand__link" :class="{ 'category-brand__body-link' : name == 'Shop by body shape'}" v-show="visibleFacets(index)">
                        <img :src="normalizeShapename(facet.name)" :alt="facet.name" v-if="(name == 'Shop by body shape') && checkCat" class="cat-body-shape" @error="bodyShapeFallback"/>
                        <h3 v-if="visibleFacets(index)">{{ facet.name }}</h3> <span v-else>{{ facet.name }}</span><span v-if="facet.count">{{ facet.count }}</span>
                    </a>
                    <div class="brand-list__toggle" :class="{ 'expanded': showAll }">
                        <button class="btn btn--toggle" v-if="this.facetsList.length > this.limit" @click.prevent="toggleVisible">{{ showAllText }}</button>
                    </div>
                </div>
            </div>
        </transition>
        <!-- <button class="btn btn--mobile" @click="toggleMenu">{{ showMenuText }}</button> -->
    </div>
</template>

<script>
    export default {
        props: {
            facetsJson: {
                default: '',
                type: String,
            },
            mainCat: {
                default: '',
                type: String,
            },
            facets: false,
            limit: {
                default: 20,
                type: Number,
            },
            name: {
                default: '',
                type: String,
            },
            attributeType: {
                default: 'Brands',
            },
            alphabeticalJson: {
                default: '',
                type: String,
            },
        },
        data() {
            return {
                showAll: false,
                active: false,
                isMobile: false,
                showMenu: false,
            };
        },
        computed: {
            facetsList() {
                let facets = this.facets;
                if (!facets || typeof facets !== 'object') {
                    try {
                        if(this.showAll && this.alphabeticalJson !== ''){
                            facets = JSON.parse(this.alphabeticalJson);
                        } else {
                            facets = JSON.parse(this.facetsJson);
                        }
                    } catch (e) {
                        facets = [];
                    }
                }
                return facets;
            },
            visibleMenu() {
                return !this.isMobile || this.showMenu;
            },
            showAllText() {
                return (this.showAll ? 'Show Fewer ' + this.attributeType : 'Show More ' + this.attributeType);
            },
            showMenuText() {
                return (this.showMenu ? 'Hide': 'Show');
            },
            checkCat(){
                if(this.mainCat == "Electric Guitar"){
                    return true
                } else {
                    return false
                }
            }
        },
        created() {
            // window.addEventListener('resize', this.resize);
            // this.resize();
        },
        methods: {
            visibleFacets(index) {
                return (this.showAll || index < this.limit || this.isMobile ? true : false);
            },
            toggleVisible() {
                this.showAll = !this.showAll;
            },
            // toggleMenu() {
            //     this.showMenu = !this.showMenu;
            // },
            // resize() {
            //     this.isMobile = Modernizr.mq('(max-width: 750px)');
            // },
            normalizeShapename(a){
                var b = a.toString().replace(' ', '-').toLowerCase()
                var c = "https://media.sweetwater.com/m/body-shapes/electric-guitars/";
                c += b;
                c += ".svg";
                return c;
            },
            bodyShapeFallback(event) {
                event.target.src = "https://media.sweetwater.com/m/body-shapes/fallback.svg"
            }
        },
    };
</script>

<style scoped lang="scss">
@import '~@sweetwater/sass-resources/sass';

.cat-body-shape {
    vertical-align: bottom;
}
.category-brand__body-link {
    display: flex;
    align-items: center;

    ~ .brand-list__toggle .btn {
        max-width: 230px;
    }
}
.brand-list__toggle {
    align-items: center;
    display: flex;
    flex: 1 1 100%;
    justify-content: flex-start;
    padding: 15px 0 10px;

    @include media('>=550px', '<=750px') {
        justify-content: center;
    }

    .btn {
        background: #fff;
        border: 1px solid #2e2e2d;
        border-radius: 4px;
        color: #2e2e2d;
        display: block;
        font-size: 0.9375rem;
        font-weight: 400;
        height: 100%;
        margin: 10px 0;
        max-width: 190px;
        padding: 0 14px 0 0;
        position: relative;
        width: 100%;

        &:hover,
        &:focus,
        &:active {
            background: #fbfafa;
        }

        &::after {
            content: '';
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 878 512'%3E%3Cpath fill='%232e2e2d' d='M382.757 451.657l55.149 55.149 441.417-441.709-55.149-55.15-386.195 386.195-384.585-384-55.077 55.15 384.439 384.365z'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            height: 8px;
            margin: 0 0 0 10px;
            max-width: 190px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 12px;
        }
    }

    &.expanded .btn::after {
        transform: translateY(-60%) rotate(180deg);
    }
}
</style>
